import styled from 'styled-components';

export const ChipGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  /* An answer is content, not a tag: let long labels wrap instead of MUI's ellipsis. */
  .MuiChip-root {
    height: auto;
    min-height: 30px;
  }

  .MuiChip-label {
    padding-top: 6px;
    padding-bottom: 6px;
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;
